import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  addressToSuburbLink,
  sanitizeDescription,
} from './VendorHeader.helpers'

import Breadcrumbs from 'components.v2/Breadcrumbs'
import DesktopContainer from 'layouts/DesktopContainer'
import VenueImage from 'components.v2/VenueImage'

import {
  ActionsContainer,
  CoverImageContainer,
  Description,
  FavouriteButton,
  FavouriteIcon,
  HeaderContainer,
  InfoSection,
  Tags,
  VenueName,
} from './styled'

import colors from 'theme/colors'

import VenueFavouriteHandler from 'enhancers/withFavouriteVenue'

import { MAX_TAGS_COUNT } from 'pages/vendor/const'
import CreateOrderParty from '../../OrderParty/CreateOrderParty'
import { ConfigContext } from 'contexts/config-context'
import get from 'lodash/get'
import isNode from 'detect-node'

const Header = props => {
  if (isNode) return null

  const { name, address = {}, tags = [], description, id } = props

  const tagsStr = (tags || [])
    .slice(0, MAX_TAGS_COUNT)
    .map(x => x.name)
    .join('  •  ')

  const config = useContext(ConfigContext)

  const isOrderPartyEnabled = get(config, 'features.order_party.enabled')

  return (
    <DesktopContainer background="orange">
      <HeaderContainer>
        <InfoSection>
          <div style={{ visibility: address ? 'visible' : 'hidden' }}>
            {/**
             * Note: render breadcrumbs with placeholder data even when no data yet
             * to render height and prevent changes on update
             */}
            <Breadcrumbs
              color="textAltPrimary"
              links={[
                { text: 'Home', url: '/' },
                addressToSuburbLink(address) || { text: '', url: '#' },
                { text: name || '' },
              ]}
            />
          </div>

          <VenueName>{name}</VenueName>
          {tagsStr && <Tags>{tagsStr}</Tags>}

          <Description>{sanitizeDescription(description)}</Description>

          <ActionsContainer>
            {isOrderPartyEnabled && <CreateOrderParty />}
            <VenueFavouriteHandler id={id}>
              {({ isFavourite, isLoading, onClick }) => {
                return (
                  <FavouriteButton disabled={isLoading} onClick={onClick}>
                    <FavouriteIcon
                      type="heart"
                      size="13"
                      fill={isFavourite ? colors['white'] : 'none'}
                      stroke={colors['white']}
                      strokeWidth={2}
                    />
                    Favourite
                  </FavouriteButton>
                )
              }}
            </VenueFavouriteHandler>
          </ActionsContainer>
        </InfoSection>

        {id && (
          <CoverImageContainer>
            <VenueImage
              shouldUseCoverImg
              ratio={[345, 185]}
              hasStatus
              {...props}
            />
          </CoverImageContainer>
        )}
      </HeaderContainer>
    </DesktopContainer>
  )
}

Header.propTypes = {
  name: PropTypes.string,
  coverImage: PropTypes.string,
  coverImages: PropTypes.arrayOf(PropTypes.string),
  homeImages: PropTypes.arrayOf(PropTypes.string),
  address: PropTypes.shape({
    suburb: PropTypes.string.isRequired,
  }),
  id: PropTypes.number,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ),
  description: PropTypes.string,
}

export default Header
